import { IGtmProperties } from '@epicuro-next/platform/tracking';
import { createActionGroup, props } from '@ngrx/store';

export const gtmTrackActions = createActionGroup({
  source: 'Tracking',
  events: {
    'gtm Track Event': props<{ action: string; properties: IGtmProperties }>(),

    'gtm Ecommerce Track Event': props<{ value: IGtmProperties }>(),

    'gtm Set User Property': props<{ value: IGtmProperties }>(),

    'gtm Collect Track Data': props<{
      name: string;
      eventMappingFunction?: string;
      payload: IGtmProperties;
    }>(),

    'gtm Send Track Event': props<{ name: string; payload: IGtmProperties }>(),
  },
});
